//
//
//
//
//
//
//
//
//
//

import ShortPost from '@/components/blog/ShortPost'
import Pageview from '@/mixins/Pageview'

export default {
  name: 'BlogPostsPage',
  components: {
    ShortPost
  },
  mixins: [Pageview],
  layout: 'blank',
  auth: false,
  async fetch () {
    await this.$store.dispatch('blog/getPosts')
  },
  computed: {
    posts () {
      return this.$store.state.blog.posts
    }
  }
}
